import { render, staticRenderFns } from "./ViewSession.vue?vue&type=template&id=0a68fa2f&scoped=true&lang=pug&"
import script from "./ViewSession.vue?vue&type=script&lang=js&"
export * from "./ViewSession.vue?vue&type=script&lang=js&"
import style0 from "./ViewSession.vue?vue&type=style&index=0&id=0a68fa2f&lang=stylus&scoped=true&"
import style1 from "./ViewSession.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a68fa2f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDialog,VFlex,VLayout})
